import React, { useCallback, memo } from 'react'
import { useDispatch } from 'react-redux'

import DateRangeFilter from 'components/DateRangeFilter/DateRangeFilter'
import { setSelectedDateRange } from 'redux/reducers/facility'

const DateRangeFilterSection = ({ selectedDateRange }) => {
  const dispatch = useDispatch()

  const handleChangeDateRange = useCallback(
    (values) => {
      dispatch(setSelectedDateRange(values))
    },
    [dispatch]
  )

  return (
    <DateRangeFilter
      selectedDateRange={selectedDateRange}
      handleChange={handleChangeDateRange}
    />
  )
}

export default memo(DateRangeFilterSection)
